<div class="cowing-footer" [ngClass]="type ? type : ''">
  <div class="container">
    <span> Â© CowingApp S.L. </span>
    <div class="links">
      <span (click)="navToPage('https://www.cowing.es/about')"> {{ 'footer.about' | translate}} </span>
      <span (click)="navToPage('https://www.cowing.es/privacy-policy')"> {{ 'footer.policy' | translate}} </span>
      <span (click)="navToPage('https://www.cowing.es/terms-and-conditions')"> {{ 'footer.terms' | translate}} </span>
    </div>
    <div class="contact">
      <div class="email">
        <a href="mailto:info@cowing.es" [ngClass]="type ? type : ''">
          <img [src]="getEmailIcon" />
          <span> info@cowing.es </span>
        </a>
      </div>
      <img [src]="getLinkedinIcon" (click)="navToPage('https://www.linkedin.com/company/becowing')" />
    </div>
  </div>

  <div class="mobile-container">
    <div class="left-column">
      <span> Â© CowingApp S.L. </span>
      <div class="contact">
        <div class="email">
          <a href="mailto:info@cowing.es" [ngClass]="type ? type : ''">
            <img [src]="getEmailIcon" />
            <span> info@cowing.es </span>
          </a>
        </div>
        <img [src]="getLinkedinIcon" (click)="navToPage('https://www.linkedin.com/company/becowing')" />
      </div>
    </div>
    <div class="right-column">
      <div class="contact">
        <div class="links">
          <span (click)="navToPage('https://www.cowing.es/about')"> {{ 'footer.about' | translate}} </span>
          <span (click)="navToPage('https://www.cowing.es/privacy-policy')"> {{ 'footer.policy' | translate}} </span>
          <span (click)="navToPage('https://www.cowing.es/terms-and-conditions')"> {{ 'footer.terms' | translate}}
          </span>
        </div>
      </div>
    </div>
  </div>
</div>